import { UiToast } from 'src/components/UI/toasts';
import { EntityImportProgressInfoResponseType } from 'src/models/ImportProgress';
import { tryCatch } from 'src/utils/tryCatch';
import { SafeAnyType } from 'src/utils/safeAny';
import { TrayIoBloomerangFieldValue, TrayIoLittleGreenLightFieldValue } from '../models/DonationPage/Section';

export type PubNubMessage<M = unknown> = {
  actualChannel: unknown;
  channel: string;
  message: {
    Created: string; // '2021-10-22T01:56:13.2184568Z'
    Description: unknown;
    Group: string;
    Id: string;
    IsNew: boolean;
    NotifyType: string;
    Payload: unknown;
    Title: unknown;
    ProgressResult?: EntityImportProgressInfoResponseType;
    UserEmail?: string;
    CampaignName?: string;
    CampaignFieldValues: TrayIoBloomerangFieldValue[] | TrayIoLittleGreenLightFieldValue[];
    FundFieldValues: TrayIoBloomerangFieldValue[] | TrayIoLittleGreenLightFieldValue[];
    AppealFieldValues: TrayIoBloomerangFieldValue[] | TrayIoLittleGreenLightFieldValue[];
    EventFieldValues?: TrayIoLittleGreenLightFieldValue[]; // Optional: only for LittleGreenLight, not Bloomerang
  } & M;
  publisher: string;
  subscribedChannel: string;
  subscription: unknown;
  timetoken: string;
};

export class PubNub {
  static joinChannel<M = unknown>(channel: string, callback: (message: PubNubMessage<M>, token: string) => void): void {
    if (process.env.NODE_ENV === 'production') {
      tryCatch(() => {
        window.RallyUp.PubNub.JoinChannel(channel);

        const token = window.EventAggregator.subscribe(channel, (id: string, message: PubNubMessage<SafeAnyType>) => {
          callback(message, token.toString());
        });
      });
    } else {
      UiToast.info("You're trying to join PubNub which is not available in dev");
    }
  }

  static leaveChannel(channel: string, token: string): void {
    tryCatch(() => {
      window.EventAggregator.unsubscribe(token);

      window.RallyUp.PubNub.LeaveChannel(channel);
    });
  }
}
